var map = {
	"./locale-provider/ar_EG.tsx": 1073,
	"./locale-provider/bg_BG.tsx": 1077,
	"./locale-provider/ca_ES.tsx": 1081,
	"./locale-provider/cs_CZ.tsx": 1085,
	"./locale-provider/de_DE.tsx": 1089,
	"./locale-provider/el_GR.tsx": 1093,
	"./locale-provider/en_GB.tsx": 1097,
	"./locale-provider/en_US.tsx": 1101,
	"./locale-provider/es_ES.tsx": 1102,
	"./locale-provider/et_EE.tsx": 1106,
	"./locale-provider/fa_IR.tsx": 1110,
	"./locale-provider/fi_FI.tsx": 1114,
	"./locale-provider/fr_BE.tsx": 1118,
	"./locale-provider/fr_FR.tsx": 1122,
	"./locale-provider/is_IS.tsx": 1126,
	"./locale-provider/it_IT.tsx": 1130,
	"./locale-provider/ja_JP.tsx": 1134,
	"./locale-provider/ko_KR.tsx": 1138,
	"./locale-provider/ku_IQ.tsx": 1142,
	"./locale-provider/nb_NO.tsx": 1146,
	"./locale-provider/nl_BE.tsx": 1150,
	"./locale-provider/nl_NL.tsx": 1154,
	"./locale-provider/pl_PL.tsx": 1158,
	"./locale-provider/pt_BR.tsx": 1162,
	"./locale-provider/pt_PT.tsx": 1166,
	"./locale-provider/ru_RU.tsx": 1170,
	"./locale-provider/sk_SK.tsx": 1174,
	"./locale-provider/sl_SI.tsx": 1178,
	"./locale-provider/sr_RS.tsx": 1181,
	"./locale-provider/sv_SE.tsx": 1185,
	"./locale-provider/th_TH.tsx": 1189,
	"./locale-provider/tr_TR.tsx": 1193,
	"./locale-provider/uk_UA.tsx": 1197,
	"./locale-provider/vi_VN.tsx": 1201,
	"./locale-provider/zh_CN.tsx": 1205,
	"./locale-provider/zh_TW.tsx": 1208
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1072;


//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 1072
// module chunks = 0